"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThirdPlatformOrderPayRequest = void 0;
var ThirdPlatformOrderPayRequest = /** @class */ (function () {
    function ThirdPlatformOrderPayRequest() {
    }
    return ThirdPlatformOrderPayRequest;
}());
exports.ThirdPlatformOrderPayRequest = ThirdPlatformOrderPayRequest;
;
//# sourceMappingURL=thirdPlatformOrderPay.request.js.map